import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasSearchQuery: boolean
}

const EmptyInsurancePoliciesComponent = ({ hasSearchQuery }: Props) => {
  return (
    <div
      data-testid="insurance-policies-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No insurance policies found</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasSearchQuery
          ? 'Try a different search.'
          : 'Create a policy to start assigning insurance products to this customer.'}
      </Typography>
    </div>
  )
}

export const EmptyInsurancePolicies = memo(EmptyInsurancePoliciesComponent)
